import { useState } from "react";
import moment from "moment";

export const useDateLimits = (isUTC = false) => {
  const getNow = () => (isUTC ? moment().utc() : moment());

  const [dateLimits, setDateLimits] = useState(() => {
    const now = getNow();
    return {
      maxDate: new Date(now.year(), now.month(), now.date()),
      maxTime: new Date(0, 0, 0, now.hour(), now.minute(), now.second()),
    };
  });

  const handleCalendarOpen = () => {
    const now = getNow();
    setDateLimits({
      maxDate: new Date(now.year(), now.month(), now.date()),
      maxTime: new Date(0, 0, 0, now.hour(), now.minute(), now.second()),
    });
  };

  const getTimeProps = (selectedValue) => {
    const selectedMoment = selectedValue
      ? (isUTC ? moment.utc(selectedValue) : moment(selectedValue))
      : null;

    const currentMoment = getNow();

    const isToday = selectedMoment
      ? selectedMoment.isSame(currentMoment, "day")
      : true;

    if (isToday) {
      return {
        minTime: new Date(0, 0, 0, 0, 0),
        maxTime: dateLimits.maxTime,
      };
    }

    return {};
  };

  return { dateLimits, handleCalendarOpen , getTimeProps};
};